<template>
  <page-banner
    v-if="!!event.types.find(item => item.must_be_staffed) && event.attendees.length < 1"
    dense
    color="orange-3"
    icon="mdi-exclamation"
    label="This appointment must be staffed, as suggested by the selected appointment type."
  />
</template>

<script>
export default {
  props: {
    event: {
      type: Object,
      required: true
    }
  }
}
</script>
